// @ts-nocheck
import React from 'react';
import {
  styled, Box, Stack, Typography,
} from '@mui/material';
import WarningAmber from '@mui/icons-material/WarningAmber';
import { Layer } from '../models/layer-settings';
import LayerPickerLayerType from './layer-picker-layer-type';

interface Props {
  item: Layer;
}

const ItemContainer = styled(Box)({
  display: 'flex',
  padding: 8,
  paddingLeft: 12,
  borderBottom: '1px solid #eee',
  fontSize: 13,
  cursor: 'pointer',
  ':hover': {
    backgroundColor: '#f7f7f7',
  },
});

const ExcessivelyLargeKMLLayerListItem: React.FC<Props> = ({ item }) => (
  <ItemContainer>
    <Stack spacing={0.5} sx={{ minWidth: 0, flex: '1 1 auto' }}>
      <Typography
        data-testid="layer-title"
        sx={{
          color: '#41403B', fontSize: '12px', maxWidth: '395px', opacity: 0.5,
        }}
        noWrap
      >
        {item.name}

      </Typography>
      { item.description?.length > 0
        ? (
          <Typography
            data-testid="layer-description"
            sx={{
              color: 'rgba(0, 0, 0, 0.6)',
              opacity: 0.5,
              WebkitLineClamp: '2',
              WebkitBoxOrient: 'vertical',
              maxWidth: '395px',
              lineHeight: 'inherit',
              fontSize: '12px',
              display: '-webkit-box',
              overflow: 'hidden',
            }}
          >
            {item.description}
          </Typography>
        ) : null }
      <LayerPickerLayerType
        layerType={item.type}
        origin={item.origin}
        fileSize={item.fileSize}
        username={item.esriUsername}
        opacity={0.5}
      />
      <Box>
        <WarningAmber sx={{
          color: '#FF9500',
          width: '0.75em',
          height: '0.75em',
          fontSize: '1rem',
          top: '2px',
          position: 'relative',
        }}
        />
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: '10px',
            color: '#FF9500',
            display: 'inline',
            paddingLeft: '5px',
          }}
        >
          KML/KMZ layers exceeding 10MB will not display on the web map.
        </Typography>
      </Box>
    </Stack>
  </ItemContainer>
);

export default ExcessivelyLargeKMLLayerListItem;
